import React, { Component } from 'react'
import WelcomeMessageBuilder from 'components/shared/MessagePreviews/WelcomeMessage'
import { List } from 'immutable'
import { Messages, PreviewState } from '../../constants'
import { injectIntl } from 'react-intl'

class WelcomeMessageBuilderContainer extends Component {
  resolveDefaultMessage() {
    const { previewState, intl } = this.props

    return previewState === PreviewState.ONLINE
      ? intl.formatMessage(Messages.defaultWelcomeMessage)
      : intl.formatMessage(Messages.defaultAwayMessage)
  }

  render() {
    const { theme, currentUser, name, intl, message, isHTMLPreview } = this.props
    const resolvedMessage = message ? message : this.resolveDefaultMessage()

    return (
      <WelcomeMessageBuilder
        backgroundColor={theme.backgroundColor}
        foregroundColor={theme.foregroundColor}
        showProfileIcon={true}
        users={List.of(currentUser)}
        title={(
          <span>{name}</span>
        )}
        isHTMLPreview={isHTMLPreview}
        message={resolvedMessage}>
        <div className="composer">
          {intl.formatMessage(Messages.typeMessage)}
        </div>
      </WelcomeMessageBuilder>
    )
  }
}

export default injectIntl(WelcomeMessageBuilderContainer)



// WEBPACK FOOTER //
// ./src/scripts/components/settings/ChatWidget/components/WelcomeMessage/components/WelcomeMessageBuilderContainer/index.js